'use client'

import { Common, RingBuilder } from '@/config/NextImport'
import { setRingBuilderReady } from '@/lib/features/ringBuilderSlice'
import { AppDispatch, AppState } from '@/lib/store'
import { usePathname, useRouter } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'js-cookie'

const BackLinkSection = (props: any) => {
  const pathname = usePathname()
  const router = useRouter()
  const dispatch = useDispatch<AppDispatch>()
  const { isRingBuilderReady } = useSelector((state: AppState) => state.ringBuilder)

  const backToListing = (e: any) => {
    e.preventDefault()
    const storageSteps: any = RingBuilder.getRingBuilder()
    const diamondUrl = storageSteps.filter((x: any) => x.step === 'diamond')[0].recent_url
    if (!Common.isNullorEmpty(diamondUrl)) {
      router.replace(diamondUrl)
    } else {
      router.replace(Common.getSanitizedUrl(pathname))
    }
  }
  const startNewFlow = () => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    RingBuilder.removeRingBuilder()
    RingBuilder.setDefaultRingBuilder(pathname, 1)
    sessionStorage.setItem('diamondListScrollY', String(0))
    router.push(Common.getSanitizedUrl(storageSteps[0].url))
    dispatch(setRingBuilderReady(!isRingBuilderReady))
  }
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="back-link-section d-flex justify-content-between align-items-center mb-2">
          <span
            className="back-link cursor"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#505050"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-chevron-left"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            <u onClick={(e) => backToListing(e)}>Back To Collection</u>
          </span>
          <span
            className="back-link cursor"
            onClick={(e) => startNewFlow()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#505050"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-chevron-left"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            <u>Start Over</u>
          </span>
        </div>
      </div>
    </div>
  )
}

export default BackLinkSection
